import { Card, Tab, Tabs } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import AddIndiaGreenHydrogen from "./AddIndiaGreenHydrogen";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import AddMembers from "./AddMembers";
import AddHydrogenEventGallery from "./AddHydrogenEventGallery";
import HelperService from "../../utility/HelperService";
const IndiaGreenHydrogen = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [data, setData] = useState<any>(null);
  const [isLoading, setLoading] = useState(false);
  const [editingMember, setEditingMember] = useState<any>(null);
  const [mode, setMode] = useState<"add" | "edit">("add");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showMembersModal, setShowMembersModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState<any>(null);
  const [draggedMember, setDraggedMember] = useState<{
    type: string;
    index: number;
  } | null>(null);
  const [showEventModal, setShowEventModal] = useState(false);
  const [editingEvent, setEditingEvent] = useState<any>(null);
  const [eventMode, setEventMode] = useState<"add" | "edit">("add");
  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });
  const [deleteIndex, setDeleteIndex] = useState<number | null>(null);
  const [showMemberDeleteModal, setShowMemberDeleteModal] = useState(false);
  const [memberToDelete, setMemberToDelete] = useState<{
    type: string;
    index: number;
  } | null>(null);

  useEffect(() => {
    getData();
  }, []);
  const handleDeleteMember = (type: string, index: number) => {
    const updatedMembers = data.members.filter(
      (m: any, i: number) =>
        !(m.type === type && data.members.indexOf(m) === index),
    );

    const body = new FormData();
    body.append("members", JSON.stringify(updatedMembers));
    body.append("id", data._id);

    WebService.fileUploadAPI({
      action: "council/addMembers",
      body,
    }).then(() => {
      toast.success("Member deleted");
      getData();
    });
  };

  const groupedMembers =
    data?.members?.reduce((acc: any, member: any) => {
      if (!acc[member.type]) acc[member.type] = [];
      acc[member.type].push(member);
      return acc;
    }, {}) || {};

  const getData = () => {
    setLoading(true);
    WebService.getAPI({
      action: `council/getContent?type=INDIA_GREEN`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};
        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err: any) => {
        setLoading(false);
        //   toast.error(err.response?.data?.message || "An error occurred");
      });
  };
  const handleMemberDragStart = (
    e: React.DragEvent,
    type: string,
    index: number,
  ) => {
    e.dataTransfer.setData("memberDrag", JSON.stringify({ type, index }));
  };
  const handleMemberDrop = (type: string, index: number) => {
    if (!draggedMember) return;
    if (draggedMember.type !== type) return;

    const updatedMembers = [...data.members];

    // same type ke members nikalo
    const sameTypeMembers = updatedMembers.filter((m: any) => m.type === type);

    // reorder
    const [moved] = sameTypeMembers.splice(draggedMember.index, 1);
    sameTypeMembers.splice(index, 0, moved);

    // merge back into original array
    let cursor = 0;
    const finalMembers = updatedMembers.map((m: any) =>
      m.type === type ? sameTypeMembers[cursor++] : m,
    );

    const body = new FormData();
    body.append("members", JSON.stringify(finalMembers));
    body.append("id", data._id);

    WebService.fileUploadAPI({
      action: "council/addMembers",
      body,
    }).then(() => {
      toast.success("Members reordered");
      getData();
    });

    setDraggedMember(null);
  };

  const reorderEvents = (fromIndex: number, toIndex: number) => {
    if (fromIndex === toIndex) return;

    const updatedEvents = [...data.events];
    const [moved] = updatedEvents.splice(fromIndex, 1);
    updatedEvents.splice(toIndex, 0, moved);

    const body = new FormData();
    body.append("events", JSON.stringify(updatedEvents));
    body.append("id", data._id);

    WebService.fileUploadAPI({
      action: `council/addEvents`,
      body,
    })
      .then(() => {
        getData();
      })
      .catch(() => {
        toast.error("Failed to reorder events");
      });
  };
  return (
    <>
      <AddIndiaGreenHydrogen
        show={showAddModal}
        handleClose={() => {
          setShowAddModal(false);
          getData();
        }}
        data={data}
      />
      <AddMembers
        show={showMembersModal}
        handleClose={() => {
          setSelectedMember(null);
          setShowMembersModal(false);
          //   getWomenLeaders();
          getData();
        }}
        data={data}
        member={editingMember}
        mode={mode}
      />
      <AddHydrogenEventGallery
        show={showEventModal}
        handleClose={() => {
          setShowEventModal(false);
          getData();
        }}
        data={data}
        event={editingEvent}
        mode={eventMode}
      />
      <div className="events-main">
        <Card className="event-card">
          <div>
            <Tabs defaultActiveKey="info" className="mt-3">
              <Tab eventKey="info" title="Info" className="p-3">
                {isLoading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: 100 }}
                  >
                    <span
                      className="spinner-border"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </div>
                ) : (
                  <>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="page-title">
                        India Green Hydrogen Council
                      </div>
                      {pagePermission.canEdit && (
                        <CustomButton
                          isLoading={false}
                          className="mt-2"
                          label={data ? "Edit" : "Add"}
                          onClick={() => {
                            setShowAddModal(true);
                          }}
                          style={{ width: 100 }}
                        />
                      )}
                    </div>
                    {data === null ? (
                      <div>No data found</div>
                    ) : (
                      <>
                        {data?.logo && (
                          <div className="mb-2 mt-2">
                            <img
                              src={data.logo}
                              alt="Event"
                              style={{ objectFit: "contain", width: 300 }}
                              className="border rounded-3 p-2"
                            />
                          </div>
                        )}
                        <div className="mb-3">
                        {data.title && <strong>Title</strong>}
                        {data?.title && <div>{data.title}</div>}
                        </div>

                        {data?.description && <strong>Description</strong>}
                        {data?.description && (
                           <div className="ql-snow">
                          <div
                            className="mt-2 px-0 ql-editor"
                            dangerouslySetInnerHTML={{
                              __html: HelperService.getPreviewableHTML(data.description),
                            }}
                          />
                          </div>
                        )}

                        {data?.ighc && data.ighc.length > 0 && (
                          <>
                            <h5 className="mt-4 mb-3">Why IGHC?</h5>

                            <div className="d-flex flex-wrap gap-3">
                              {data.ighc.map((keyarea: any, index: number) => (
                                <div
                                  key={keyarea._id || index}
                                  className="border rounded-3 p-3 d-flex flex-column align-items-center"
                                  style={{ width: 220 }}
                                >
                                  {/* LOGO */}
                                  {keyarea.logo && (
                                    <img
                                      src={keyarea.logo}
                                      alt={
                                        keyarea.title || `Key Area ${index + 1}`
                                      }
                                      style={{
                                        width: 160,
                                        height: 120,
                                        objectFit: "contain",
                                      }}
                                      className="mb-2"
                                    />
                                  )}

                                  {/* TITLE */}
                                  {keyarea.title && (
                                    <div className="text-center fw-semibold">
                                      {keyarea.title}
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </>
                        )}

                        {data?.events && data.events.length > 0 && (
                          <>
                            <h5 className="mt-4 mb-3">Event Gallery</h5>

                            <div className="d-flex flex-wrap gap-3">
                              {data.events.map((event: any, index: number) => (
                                <div
                                  key={event._id || index}
                                  className="border rounded-3 p-3"
                                  style={{ width: 240 }}
                                >
                                  {/* EVENT IMAGES */}
                                  {event.images && event.images.length > 0 && (
                                    <div className="d-flex flex-wrap justify-content-center gap-2 mb-2">
                                      {event.images.map(
                                        (img: any, imgIndex: number) => (
                                          <img
                                            key={imgIndex}
                                            src={img.image}
                                            alt={`Event ${index + 1} - ${
                                              imgIndex + 1
                                            }`}
                                            style={{
                                              width: 90,
                                              height: 70,
                                              objectFit: "cover",
                                              borderRadius: 6,
                                            }}
                                          />
                                        ),
                                      )}
                                    </div>
                                  )}

                                  {/* TITLE */}
                                  {event.title && (
                                    <div className="text-center fw-semibold mt-1">
                                      {event.title}
                                    </div>
                                  )}

                                  {/* DATE */}
                                  {event.publishDate && (
                                    <div className="text-center text-muted small">
                                      {event.publishDate}
                                    </div>
                                  )}

                                  {/* LOCATION */}
                                  {event.location && (
                                    <div className="text-center text-muted small">
                                      {event.location}
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              </Tab>

              <Tab eventKey="members" title="Members">
                <div className="p-3">
                  {/* Add Member button */}
                  <div className="d-flex justify-content-end mb-3">
                    {pagePermission.canEdit && (
                      <CustomButton
                        isLoading={false}
                        label="Add Member"
                        onClick={() => {
                          setMode("add");
                          setEditingMember(null);
                          setShowMembersModal(true);
                        }}
                        style={{ width: 180 }}
                      />
                    )}
                  </div>

                  {/* No members */}
                  {(!data?.members || data.members.length === 0) && (
                    <div>No members found</div>
                  )}

                  {/* Type-wise Tabs */}
                  {Object.keys(groupedMembers).length > 0 && (
                    <Tabs
                      className="mt-2"
                      defaultActiveKey={Object.keys(groupedMembers)[0]}
                    >
                      {Object.keys(groupedMembers).map((type) => (
                        <Tab
                          key={type}
                          eventKey={type}
                          title={type.replace("_", " ")}
                        >
                          <div className="mt-3">
                            <div className="d-flex flex-wrap gap-3">
                              {groupedMembers[type].map(
                                (member: any, index: number) => (
                                  <div
                                    key={index}
                                    draggable
                                    onDragStart={() =>
                                      setDraggedMember({ type, index })
                                    }
                                    onDragOver={(e) => e.preventDefault()}
                                    onDrop={() => handleMemberDrop(type, index)}
                                    className="d-flex flex-column align-items-center border rounded p-2"
                                    style={{ width: 160, cursor: "grab" }}
                                  >
                                    {/* LOGO */}
                                    {member.logo && (
                                      <img
                                        src={member.logo}
                                        alt={member.name}
                                        style={{
                                          objectFit: "cover",
                                          width: 100,
                                          height: 100,
                                          borderRadius: "50%",
                                        }}
                                      />
                                    )}

                                    {/* NAME */}
                                    {/* <div className="mt-2 text-center">
                                      <strong>{member.name}</strong>
                                    </div> */}

                                    {/* ACTIONS */}
                                    <div className="mt-2 d-flex gap-2">
                                      <PencilFill
                                        className="cursor-pointer"
                                        onClick={() => {
                                          setMode("edit");
                                          setEditingMember({
                                            ...member,
                                            index,
                                          });
                                          setShowMembersModal(true);
                                        }}
                                      />

                                      <TrashFill
                                        color="#DC143C"
                                        className="cursor-pointer"
                                        onClick={() => {
                                          setMemberToDelete({ type, index });
                                          setShowMemberDeleteModal(true);
                                        }}
                                      />
                                    </div>
                                  </div>
                                ),
                              )}
                            </div>
                          </div>
                        </Tab>
                      ))}
                    </Tabs>
                  )}
                </div>
              </Tab>

              <Tab eventKey="events" title="Event Gallery">
                <div className="p-3">
                  {/* ADD BUTTON */}
                  <div className="d-flex justify-content-end mb-3">
                    {pagePermission.canEdit && (
                      <CustomButton
                        label="Add Event Gallery"
                        isLoading={false}
                        onClick={() => {
                          setEventMode("add");
                          setEditingEvent(null);
                          setShowEventModal(true);
                        }}
                        style={{ width: 200 }}
                      />
                    )}
                  </div>

                  {/* NO EVENTS */}
                  {(!data?.events || data.events.length === 0) && (
                    <div>No event gallery found</div>
                  )}

                  {/* EVENTS LIST */}
                  {data?.events && data.events.length > 0 && (
                    <div className="d-flex flex-wrap gap-3">
                      {data.events.map((event: any, index: number) => (
                        <div
                          key={index}
                          draggable
                          onDragStart={(e) =>
                            e.dataTransfer.setData(
                              "eventIndex",
                              index.toString(),
                            )
                          }
                          onDragOver={(e) => e.preventDefault()}
                          onDrop={(e) => {
                            const fromIndex = Number(
                              e.dataTransfer.getData("eventIndex"),
                            );
                            reorderEvents(fromIndex, index);
                          }}
                          className="border rounded p-3 bg-light"
                          style={{
                            width: 320,
                            cursor: "move",
                            background: "#fff",
                          }}
                        >
                          {/* DRAG HANDLE */}
                          <div
                            style={{
                              cursor: "grab",
                              color: "#888",
                              marginBottom: 6,
                            }}
                            title="Drag to reorder"
                          >
                            ☰
                          </div>

                          {/* IMAGE */}
                          {event.images &&
                            event.images.length > 0 &&
                            event.images[0]?.image && (
                              <img
                                src={event.images[0].image}
                                alt={event.title}
                                style={{
                                  width: "100%",
                                  height: 140,
                                  objectFit: "contain",
                                  borderRadius: 6,
                                }}
                                className="mb-2"
                              />
                            )}

                          <strong>{event.title}</strong>
                          <div
                            className="text-muted mt-1"
                            style={{ fontSize: 13 }}
                          >
                            {event.description}
                          </div>

                          {/* ACTIONS */}
                          <div className="d-flex gap-2 mt-2">
                            <PencilFill
                              className="cursor-pointer"
                              onClick={() => {
                                setEventMode("edit");
                                setEditingEvent({ ...event, index });
                                setShowEventModal(true);
                              }}
                            />
                            <TrashFill
                              color="#DC143C"
                              className="cursor-pointer"
                              onClick={() => {
                                setDeleteIndex(index);
                                setShowDeleteModal(true);
                              }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </Tab>
            </Tabs>
          </div>
        </Card>
        {showDeleteModal && (
          <div
            className="modal fade show d-block"
            style={{ background: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Delete</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowDeleteModal(false)}
                  />
                </div>

                <div className="modal-body">
                  Are you sure you want to delete this event gallery?
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowDeleteModal(false)}
                  >
                    No
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      if (deleteIndex === null) return;

                      const updated = data.events.filter(
                        (_: any, i: number) => i !== deleteIndex,
                      );

                      const body = new FormData();
                      body.append("events", JSON.stringify(updated));
                      body.append("id", data._id);

                      WebService.fileUploadAPI({
                        action: `council/addEvents`,
                        body,
                      }).then(() => {
                        toast.success("Event deleted");
                        setShowDeleteModal(false);
                        setDeleteIndex(null);
                        getData();
                      });
                    }}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showMemberDeleteModal && (
          <div
            className="modal fade show d-block"
            style={{ background: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Delete</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setShowMemberDeleteModal(false);
                      setMemberToDelete(null);
                    }}
                  />
                </div>

                <div className="modal-body">
                  Are you sure you want to delete this member?
                </div>

                <div className="modal-footer">
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowMemberDeleteModal(false);
                      setMemberToDelete(null);
                    }}
                  >
                    No
                  </button>

                  <button
                    className="btn btn-danger"
                    onClick={() => {
                      if (!memberToDelete) return;

                      handleDeleteMember(
                        memberToDelete.type,
                        memberToDelete.index,
                      );

                      setShowMemberDeleteModal(false);
                      setMemberToDelete(null);
                    }}
                  >
                    Yes, Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default IndiaGreenHydrogen;
